import { useContext } from 'react';
import { PowerBiContext } from '../components/power-bi/power-bi-provider';

export function usePowerBiContext() {
  return useContext(PowerBiContext);
}
